import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js";
import { REPORT_TYPES } from "../../../constants/app-constant";
const {
  JournalistNOARanking,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  PublicationTonalityNOARanking,
  CityWiseNOARanking,
  CityWiseNOATrend,
  CityWiseTonality,
  StateWiseTonality,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  CityWiseCCMRanking,
  CityWiseMAVRanking,
  PLATFORM_RANK,
  PLATFORM_TONALITY,
  PLATFORM_TREND,
} = REPORT_TYPES;

export const StackedBarChart = function ({
  data,
  chartTitle,
  xAxisLabel,
  yAxisLabel,
  xAxisMinTick,
  xAxisMaxTick,
  xAxisTickStep,
  beginAtZero,
  graphApiResponse,
  reportType,
  onEntityClick,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
}) {
  const chartContainer = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    setChartData(graphApiResponse);
  }, [graphApiResponse]);

  useEffect(() => {
    redrawChart();
  }, [chartData]);

  const redrawChart = () => {
    if (
      !chartContainer ||
      !chartContainer.current ||
      !Object.keys(chartData).length
    ) {
      return;
    }
    if (chartInstance) {
      chartInstance.data = chartData;
      chartInstance.update();
      return;
    }
    const ctx = chartContainer.current.getContext("2d");
    const chart = new Chart(ctx, {
      type: "bar",
      data: chartData,
      options: {
        plugins: {
          labels: false,
        },
        title: {
          display: !!chartTitle,
          text: chartTitle,
          margin: 10,
        },
        tooltips: {
          mode: "point",
          intersect: false,
        },
        legend: {
          labels: {
            boxWidth: 12,
          },
          maxHeight: 65,
        },
        exporting: {
          chartOptions: {
            legend: {
              enabled: true,
              verticalAlign: "bottom",
              maxHeight: 500,
              margin: 25,
            },
          },
        },
        responsive: true,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: (() => {
                const ticks = {};
                if (typeof beginAtZero !== "undefined") {
                  ticks.beginAtZero = beginAtZero;
                }
                ticks.userCallback = function (label) {
                  if (Math.floor(label) === label) {
                    return label;
                  }
                };
                return ticks;
              })(),
            },
          ],
        },
      },
    });
    setChartInstance(chart);
  };

  const handleBarClick = (e, { legend, label }) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_RANK ||
        reportType === PLATFORM_TREND
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend
      ) {
        routeParams.date = label;
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType == REPORT_TYPES.SOV || reportType === PLATFORM_TREND) {
        routeParams.date = label;
      }
      if (
        reportType === CityWiseNOARanking ||
        reportType === CityWiseCCMRanking
      ) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === PublicationTonalityNOARanking ||
        reportType === CityWiseTonality ||
        reportType === StateWiseTonality ||
        reportType === CityWiseCCMTonality ||
        reportType === CityWiseMAVTonality ||
        reportType === PLATFORM_TONALITY
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }
      if (reportType == PLATFORM_RANK) {
        routeParams.channel_type = label;
      }
      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <canvas
        ref={chartContainer}
        onClick={(e) => {
          let activePoint = chartInstance.getElementAtEvent(e)[0];
          if (activePoint) {
            const clickedEntity =
              graphApiResponse.labels[activePoint["_index"]];
            const legend =
              activePoint._chart.legend.legendItems[activePoint._datasetIndex]
                .text;
            handleBarClick(e, { legend, label: clickedEntity });
          }
        }}
        ref={chartContainer}
      ></canvas>
    </div>
  );
};
